import React, { useState, useRef, useCallback, useContext } from 'react';

import { Link, useNavigate } from 'react-router-dom';

import { LoginOauth } from '../login-oauth/LoginOauth';
import Button, { ButtonTypes } from 'devextreme-react/button';
import Form, { Item, Label, ButtonItem, ButtonOptions, RequiredRule, EmailRule } from 'devextreme-react/form';
import LoadIndicator from 'devextreme-react/load-indicator';
import notify from 'devextreme/ui/notify';


import { ThemeContext } from '../../../theme/theme';

import './LoginForm.scss';
import { loginRedirect } from '../../../utils/authUtils';
import { useMsal } from '@azure/msal-react';

function getButtonStylingMode(theme) {
  return theme === 'dark' ? 'outlined' : 'contained';
}

export const LoginForm = ({ resetLink, createAccountLink }) => {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const formData = useRef({ email: '', password: '' });
  const themeContext = useContext(ThemeContext);
 const { instance, accounts } = useMsal();
  const onSubmit = useCallback(
    async(e) => {
      e.preventDefault();
     
      setLoading(true);

      const result = await loginRedirect(instance);
      if (result.isOk) {
        navigate('/');
      } else {
        setLoading(false);
        notify(result.message, 'error', 2000);
      }
    },
    [loginRedirect]
  );

  const onCreateAccountClick = useCallback(() => {
    navigate(createAccountLink);
  }, [navigate]);

  return (
    <form className={'login-form'} onSubmit={onSubmit}>
      <Form formData={formData.current} disabled={loading}>
        <ButtonItem>
          <ButtonOptions
            width={'100%'}
            type={'default'}
            useSubmitBehavior={true}
          >
            <span className="dx-button-text">
              {
                loading
                  ? <LoadIndicator width={'24px'} height={'24px'} visible={true} />
                  : 'Sign In'
              }
            </span>
          </ButtonOptions>
        </ButtonItem>

      </Form>
    </form>
  );
};


